import React, { ReactNode, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RotatingLines } from "react-loader-spinner";
import { useAppDispatch } from "../../../hooks/hooks";
import storePersist from "../../../redux/storePersist";
import * as R from 'ramda';
import { selectEventsCreatedItem, selectEventsListItems } from "../../../redux/event/events/selector";
import { selectTicketsListItems } from "../../../redux/tickets/selector";
import { eventSubscriptions } from "../../../redux/event-subscriptions/action";
import { events } from "../../../redux/event/events/action";
import { tickets } from "../../../redux/tickets/action";
import { useNavigate } from "react-router-dom";


export const EventsBooking: React.FC = () => {
  const dispatch = useAppDispatch();
  const [topics, setTopics] = useState<any>([]);
  const statesItem = storePersist?.get("states")?.current?.items;
  const countriesItem = storePersist?.get("countries")?.current?.items;
  const [isButtonLoading, setIsButtonLoading] = useState<boolean>(false)
  const Eventslist = useSelector(selectEventsListItems);
  const Ticketslist = useSelector(selectTicketsListItems)
  const listevents = useSelector(selectEventsCreatedItem)
  const navigate = useNavigate();
  const [selectedEvents, setSelectedEvents] = useState<any>({


  });

  const resetForm = () => {
    setSelectedEvents({
      Login: {
        Phone: "",
        Email: ""
      },
      UserProfile: {
        FirstName: "",
        LastName: "",
        PersonTitle: ""
      },
      ONEUserInfo: {
        Biography: null,
        PhotoUrl: null,
        IsONEUserVerified: true,
        StartupName: "",
        YearsInOperation: "",
        IsTechFirstInnovation: true,
        StageOfTheStartup: "",
        Sector: "",
        WebsiteLink: "",
        utm_source: null,
        utm_medium: null,
        utm_campaign: null,
        utm_term: null,
        utm_content: null
      },
      Account: {
        IsPersonAccount: true,
        Name: "",
        TypeId: ""
      },
      PrimaryAddress: {
        address1: "",
        address2: "",
        city: "",
        CountryId: "",
        StateProvinceId: "",
        ZipPostalCode: "",
      }
    });
  };
  useEffect(() => {
    if (listevents?.isSuccess) {
      dispatch(eventSubscriptions.resetAction({ actionType: 'create' }))
      dispatch(eventSubscriptions.create({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/one/event/bookings`,
        entity: 'subscription',
        jsonData: {
          Records: [
            {

              "Email": selectedEvents?.Login?.Email,
              "PhoneNumber": selectedEvents?.Login?.Phone,
              "OwnerType": "Events",
              "EventTicketId": selectedEvents?.EventTicketId,
              "EventId": selectedEvents?.EventId,
              "Quantity": selectedEvents?.Quantity,
              "IsExistingUser": selectedEvents?.IsExistingUser || false,

            }
          ]
        }

      }))
      resetForm();

      dispatch(events.resetAction({ actionType: 'create' }))
    }
  }, [listevents]);

  const handleSubmit = async (event: any) => {
    event.preventDefault();
    const data = {
      "Login": {
        "Phone": selectedEvents?.Login?.Phone,
        "Email": selectedEvents?.Login?.Email,
      },

      "UserProfile": {
        "FirstName": selectedEvents?.UserProfile?.FirstName,
        "LastName": "",
        "PersonTitle": ""
      },
      "ONEUserInfo": {
        "Biography": null,
        "PhotoUrl": null,
        "IsONEUserVerified": true,
        "StartupName": selectedEvents?.ONEUserInfo?.StartupName,
        "YearsInOperation": "",
        "IsTechFirstInnovation": true,
        "StageOfTheStartup": selectedEvents?.ONEUserInfo?.StageOfTheStartup,
        "Sector": selectedEvents?.ONEUserInfo?.Sector,
        "WebsiteLink": selectedEvents?.PrimaryAddress?.WebsiteLink,
        "utm_source": null,
        "utm_medium": null,
        "utm_campaign": null,
        "utm_term": null,
        "utm_content": null
      },

      "Account": {
        "IsPersonAccount": true,
        "Name": "ONE User 001",
        "TypeId": 440
      },

      "PrimaryAddress": {
        "address1": selectedEvents?.PrimaryAddress?.address1,
        "address2": selectedEvents?.PrimaryAddress?.address2,
        "city": selectedEvents?.PrimaryAddress?.city,
        "CountryId": selectedEvents?.PrimaryAddress?.CountryId,
        "StateProvinceId": selectedEvents?.PrimaryAddress?.StateProvinceId,
        "ZipPostalCode": selectedEvents?.PrimaryAddress?.ZipPostalCode,
      }




    }
    if (!selectedEvents?.IsExistingUser) {
      await dispatch(events.resetAction({ actionType: 'create' }))
      await dispatch(events.create({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/one/one-users`,
        entity: 'eventsSubscriptions',
        jsonData: {
          records: [
            data
          ]
        }
      }))


      await resetForm();

    } else {
      dispatch(eventSubscriptions.create({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/one/event/bookings`,
        entity: 'subscription',
        jsonData: {
          Records: [
            {
              "Email": selectedEvents?.Email,
              "PhoneNumber": selectedEvents?.Phone,
              "OwnerType": "Events",
              "EventTicketId": selectedEvents?.EventTicketId,
              "EventId": selectedEvents?.EventId,
              "Quantity": selectedEvents?.Quantity,
              "IsExistingUser": selectedEvents?.IsExistingUser || false,

            }
          ]
        }

      }))
      resetForm();
    }
  }

  const handleInnerFormChange: any = (event: any, field: string, data: any) => {
    const fields = R.split(
      '.',
      field
    );
    const value = { ...data, [fields[1]]: event }// inner data update
    setSelectedEvents({ ...selectedEvents, [fields[0]]: value });
  }

  const handleChange: any = (event: any, field: string) => {
    setSelectedEvents({ ...selectedEvents, [field]: event })

  }

  const dummyData = [{
    id: 1,
    Name: "Events Name 1"
  },
  {
    id: 2,
    Name: "Events Name 2"
  }, {
    id: 3,
    Name: "Events Name 3"
  }, {
    id: 4,
    Name: "Events Name 4"
  }, {
    id: 5,
    Name: "Events Name 5"
  }]

  const dataToRender = Eventslist?.result?.items?.length > 0
    ? Eventslist.result.items
    : dummyData;

  useEffect(() => {
    dispatch(events.list({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/e-appilcations/event/events/list`,
      entity: 'events',
      jsonData: {
        "Context": {
          "Subscription": "ONE",
          "Domain": "ONE",
          "SubDomains": [],
          "Network": "Internal",
          "Application": "Management",
          "Channel": "Portal"
        },
        "Records": [
          {
            "Id": 0
          }
        ],

      }

    }));
  }, []);

  useEffect(() => {
    dispatch(tickets.list({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/e-appilcations/event/tickets/list`,
      entity: 'tickets',
      jsonData: {
        Filters: [
          {
            FieldName: 'EventId',
            FilterOperatorId: 1,
            FieldValue: selectedEvents?.EventId,
            FieldType: 'number'
          }
        ]
      }
    }));
  }, [selectedEvents]);


  useEffect(() => {
    if (Eventslist) {
      setTopics(Eventslist?.result?.items);
    }
  }, [Eventslist])




  const H2: React.FC<{ children: ReactNode; kicker?: string; center?: boolean }> = ({ children, kicker, center }) => (
    <div className={`mb-8 ${center ? "text-center" : ""}`}>
      {kicker && <div className="mb-2 text-sm font-semibold tracking-widest uppercase text-indigo-600">{kicker}</div>}
      <h2 className="text-3xl md:text-4xl font-extrabold text-slate-800">{children}</h2>
    </div>
  );


  return (
    <div id="join" className="bg-gradient-to-b from-slate-50 to-white border-t border-slate-200">
      <div className="py-16">
        <H2 kicker="Join" center>Become a member or a Chapter Lead</H2>

        <div className="grid lg:grid-cols-3 gap-8">
          <div className="p-6 lg:col-span-2">
            <form className="grid grid-cols-1 sm:grid-cols-2 gap-6">

              <div className="sm:col-span-2 flex items-center">
                <input
                  type="checkbox"
                  id="IsExistingUser"
                  checked={selectedEvents?.IsExistingUser || false}
                  onChange={(e) => handleChange(e.target.checked, "IsExistingUser")}
                  className="mr-2 w-4 h-4"
                />
                <label htmlFor="IsExistingUser" className="text-sm text-slate-600">Are you already registered?</label>
              </div>


              {!selectedEvents?.IsExistingUser && (
                <>
                  <div>
                    <label className="text-sm text-slate-600">Full Name</label>
                    <input
                      type="text"
                      value={selectedEvents?.UserProfile?.FirstName || ""}
                      onChange={(event) => {
                        handleInnerFormChange(
                          event.target.value,
                          'UserProfile.FirstName',
                          selectedEvents?.UserProfile
                        );
                      }}
                      placeholder="Your name"
                      required
                      className="mt-1 w-full rounded-xl border border-slate-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    />
                  </div>

                  <div>
                    <label className="text-sm text-slate-600">Email</label>
                    <input
                      type="email"
                      value={selectedEvents?.Login?.Email || ""}
                      onChange={(event) => {
                        handleInnerFormChange(
                          event.target.value,
                          'Login.Email',
                          selectedEvents?.Login
                        );
                      }}
                      placeholder="you@email.com"
                      required
                      className="mt-1 w-full rounded-xl border border-slate-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    />
                  </div>

                  <div>
                    <label className="text-sm text-slate-600">Phone</label>
                    <input
                      type="text"
                      maxLength={10}
                      value={selectedEvents?.Login?.Phone || ""}
                      onChange={(event) => {
                        handleInnerFormChange(
                          event.target.value.replace(/\D/g, ''),
                          'Login.Phone',
                          selectedEvents?.Login
                        );
                      }}
                      placeholder="10-digit number"
                      required
                      className="mt-1 w-full rounded-xl border border-slate-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    />
                    {selectedEvents?.Login?.Phone && selectedEvents?.Login?.Phone.length < 10 && (
                      <span className="text-red-600 text-xs">Please enter a valid number.</span>
                    )}
                  </div>

                  <div>
                    <label className="text-sm text-slate-600">Building</label>
                    <input
                      type="text"
                      value={selectedEvents?.PrimaryAddress?.address1 || ""}
                      onChange={(event) => {
                        handleInnerFormChange(
                          event.target.value,
                          'PrimaryAddress.address1',
                          selectedEvents?.PrimaryAddress
                        );
                      }}
                      placeholder="Building"
                      required
                      className="mt-1 w-full rounded-xl border border-slate-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    />
                  </div>

                  <div>
                    <label className="text-sm text-slate-600">Locality</label>
                    <input
                      type="text"
                      value={selectedEvents?.PrimaryAddress?.address2 || ""}
                      onChange={(event) => {
                        handleInnerFormChange(
                          event.target.value,
                          'PrimaryAddress.address2',
                          selectedEvents?.PrimaryAddress
                        );
                      }}
                      placeholder="Locality"
                      required
                      className="mt-1 w-full rounded-xl border border-slate-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    />
                  </div>

                  <div>
                    <label className="text-sm text-slate-600">City</label>
                    <input
                      type="text"
                      value={selectedEvents?.PrimaryAddress?.city || ""}
                      onChange={(event) => {
                        handleInnerFormChange(
                          event.target.value,
                          'PrimaryAddress.city',
                          selectedEvents?.PrimaryAddress
                        );
                      }}
                      placeholder="City"
                      required
                      className="mt-1 w-full rounded-xl border border-slate-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    />
                  </div>

                  <div>
                    <label className="text-sm text-slate-600">Pincode</label>
                    <input
                      type="text"
                      value={selectedEvents?.PrimaryAddress?.ZipPostalCode || ""}
                      onChange={(event) => {
                        handleInnerFormChange(
                          event.target.value,
                          'PrimaryAddress.ZipPostalCode',
                          selectedEvents?.PrimaryAddress
                        );
                      }}
                      placeholder="Pincode"
                      required
                      className="mt-1 w-full rounded-xl border border-slate-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    />
                  </div>

                  <div>
                    <label className="text-sm text-slate-600">Country</label>
                    <select
                      value={selectedEvents?.PrimaryAddress?.CountryId || ""}
                      onChange={(event) => handleInnerFormChange(event.target.value, 'PrimaryAddress.CountryId',
                        selectedEvents?.PrimaryAddress
                      )}
                      required
                      className="mt-1 w-full rounded-xl border border-slate-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    >
                      <option value="" disabled>Select Country</option>
                      {countriesItem.map((c: any) => (
                        <option key={c.Id} value={c.Id}>{c.Name}</option>
                      ))}
                    </select>
                  </div>

                  <div>
                    <label className="text-sm text-slate-600">State</label>
                    <select
                      value={selectedEvents?.PrimaryAddress?.StateProvinceId || ""}
                      onChange={(event) => handleInnerFormChange(event.target.value, 'PrimaryAddress.StateProvinceId',
                        selectedEvents?.PrimaryAddress
                      )}
                      required
                      className="mt-1 w-full rounded-xl border border-slate-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    >
                      <option value="" disabled>Select State</option>
                      {statesItem.length > 0 ? (
                        statesItem.map((s: any) => <option key={s.Id} value={s.Id}>{s.Name}</option>)
                      ) : (
                        <option disabled>No states available</option>
                      )}
                    </select>
                  </div>
                </>
              )}

              {/* Existing User Form */}
              {selectedEvents?.IsExistingUser && (
                <div className="sm:col-span-2 space-y-4">
                  {!selectedEvents?.Email && !selectedEvents?.Phone && (
                    <label className="text-sm text-slate-600">
                      Please enter <span className="text-blue-600 font-semibold">either your Email or Phone Number</span>
                    </label>
                  )}

                  <div className="flex space-x-4">
                    {!selectedEvents?.Phone && (
                      <div className="flex-1">
                        <label className="text-sm text-slate-600">Email</label>
                        <input
                          type="email"
                          required
                          value={selectedEvents?.Email || ""}
                          onChange={(e) => handleChange(e.target.value, "Email")}
                          placeholder="you@email.com"
                          className="mt-1 w-full rounded-xl border border-slate-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        />
                      </div>
                    )}

                    {!selectedEvents?.Email && (
                      <div className="flex-1">
                        <label className="text-sm text-slate-600">Phone</label>
                        <input
                          type="text"
                          maxLength={10}
                          required
                          value={selectedEvents?.Phone || ""}
                          onChange={(e) => handleChange(e.target.value.replace(/\D/g, ""), "Phone")}
                          placeholder="10-digit number"
                          className="mt-1 w-full rounded-xl border border-slate-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        />
                        {selectedEvents?.Phone?.length > 0 && selectedEvents?.Phone?.length < 10 && (
                          <span className="text-red-600 text-xs">Please enter a valid number.</span>
                        )}
                      </div>
                    )}
                  </div>

                </div>
              )}


              <div >
                <label className="text-sm text-slate-600">Select a Event</label>
                <select
                  value={selectedEvents?.EventId || ''}
                  onChange={(event) => handleChange(event.target.value, 'EventId')}
                  required
                  className="mt-1 w-full rounded-xl border border-slate-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                >
                  <option value="" disabled>Pick a Event…</option>
                  {topics.map((c: any) => (
                    <option key={c.Id} value={c.Id}>{c.Name}</option>
                  ))}
                </select>
              </div>


              <>
                {selectedEvents?.EventId && (
                  <div >
                    <label className="text-sm text-slate-600">Select a Ticket</label>
                    <select
                      onChange={(event) => handleChange(event.target.value, 'EventTicketId')}
                      value={selectedEvents?.EventTicketId || ''}
                      required
                      className="mt-1 w-full rounded-xl border border-slate-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    >
                      <option value="" disabled>Pick a Ticket…</option>
                      {Ticketslist?.result?.items?.map((c) => (
                        <option key={c.Id} value={c.Id}>{c.Name}</option>
                      ))}
                    </select>
                  </div>
                )}

                {selectedEvents?.EventTicketId && (
                  <div >
                    <label className="text-sm text-slate-600">No of Tickets</label>
                    <input
                      type="text"
                      onChange={(event) => handleChange(event.target.value, 'Quantity')}
                      value={selectedEvents?.Quantity || ''}
                      placeholder="No of Tickets"
                      required
                      className="mt-1 w-full rounded-xl border border-slate-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    />
                  </div>
                )}
              </>



              <div className="sm:col-span-2 flex justify-center space-x-4">
                {/* Subscribe Button */}
                <button
                  type="submit"
                  onClick={handleSubmit}
                  className="inline-flex items-center justify-center px-6 py-3 rounded-xl 
               bg-indigo-600 text-white font-semibold shadow hover:bg-indigo-700 
               focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                >
                  {isButtonLoading ? (
                    <RotatingLines
                      strokeColor="white"
                      strokeWidth="5"
                      animationDuration="0.75"
                      width="24"
                      visible={true}
                    />
                  ) : (
                    "Subscribe"
                  )}
                </button>

                {/* Back Button */}
                <button
                  type="button"
                  onClick={() => navigate("/communities")}
                  className="inline-flex items-center justify-center px-6 py-3 rounded-xl 
               bg-gray-500 text-white font-semibold shadow hover:bg-gray-600 
               focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-400"
                >
                  Back
                </button>
              </div>



            </form>
          </div>
          <div className="space-y-4">
            <div className="p-6">
              <div className="font-semibold text-slate-900">How membership works</div>
              <ul className="mt-2 text-sm text-slate-600 list-disc pl-5 space-y-1">
                <li>Free to join. Upgrade to workshops via Academy when needed.</li>
                <li>Access playbooks, tools, and partner programs.</li>
                <li>Attend city meetups and online clinics.</li>
              </ul>
            </div>
            <div className="p-6">
              <div className="font-semibold text-slate-900">Partner with us</div>
              <div className="mt-2 text-sm text-slate-600">Banks, logistics, SaaS, and corporates can run clinics, offer credits, and sponsor cohorts.</div>
              <a href="#" className="mt-3 inline-flex items-center justify-center rounded-full px-4 py-2 border border-slate-300 hover:bg-slate-50 text-sm font-semibold">View Partner Guide</a>
            </div>
          </div>



        </div>
      </div>
    </div>
  );
};
